import React, { useMemo, useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Modal from '../../components/Modal/Modal';
import Button from '../../components/Button/Button';
import DealCreateCreditAppeal from './DealCreate/DealCreateCreditAppeal';
import updateCreditAppeal from '../../api/creditPlatform/updateCreditAppeal';
import alert from '../../helpers/alert';

const UpdateCreditAppeal = ({ appeal, orders, deal, documents, update }) => {
  const [showModal, setShowModal] = useState(false);
  const [sendFormLoading, setSendFormLoading] = useState(false);

  const defaultValues = useMemo(() => {
    try {
      return JSON.parse(appeal?.json);
    } catch (e) {
      return {};
    }
  }, [appeal]);

  const handleSubmit = (payload, _documents, files) => {
    setSendFormLoading(true);

    return updateCreditAppeal(
      {
        ...payload,
        bussinessKey: appeal?.bankOwnerId,
        bankId: appeal?.id,
        MaritalStatus: payload?.MaritalStatus?.value,
      },
      files
    )
      // { sent } читает анкета — по нему она решает, можно ли стирать черновик.
      .then(() => {
        alert.success('Данные заявки успешно обновлены');
        setShowModal(false);
        update();
        return { sent: true };
      })
      .catch((err) => {
        alert.error(err?.response?.data || 'Ошибка при обновлении заявки');
        return { sent: false };
      })
      .finally(() => setSendFormLoading(false));
  };

  return (
    <>
      <Button fill text="Обновить данные" onClick={() => setShowModal(true)} />
      <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        width="100%"
        contentStyle={{ maxWidth: 800 }}
      >
        <DealCreateCreditAppeal
          onSubmit={handleSubmit}
          deal={deal}
          orders={orders}
          agreementModal={false}
          setAgreementModal={() => {}}
          sendFormLoading={sendFormLoading}
          creditAppeals={[]}
          defaultValues={defaultValues}
          udvIsRequired={false}
        />
      </Modal>
    </>
  );
};

export default UpdateCreditAppeal;
